<template>
    <router-view></router-view>
</template>

<script>
  export default {
    name: 'VenueLayout'
  };
</script>
